"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * reef REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorModelToJSON = exports.ErrorModelFromJSONTyped = exports.ErrorModelFromJSON = void 0;
function ErrorModelFromJSON(json) {
    return ErrorModelFromJSONTyped(json, false);
}
exports.ErrorModelFromJSON = ErrorModelFromJSON;
function ErrorModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'httpStatus': json['http_status'],
        'message': json['message'],
    };
}
exports.ErrorModelFromJSONTyped = ErrorModelFromJSONTyped;
function ErrorModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'http_status': value.httpStatus,
        'message': value.message,
    };
}
exports.ErrorModelToJSON = ErrorModelToJSON;
